import { render, staticRenderFns } from "./enterprise-table.vue?vue&type=template&id=921abeb6&scoped=true"
import script from "./enterprise-table.vue?vue&type=script&lang=js"
export * from "./enterprise-table.vue?vue&type=script&lang=js"
import style0 from "./enterprise-table.vue?vue&type=style&index=0&id=921abeb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921abeb6",
  null
  
)

export default component.exports